














































































































































































































































































































































































































































































import PageLayout from '@/components/page/PageLayout.vue'
import { Component, Prop, Vue, Watch, Mixins } from 'vue-property-decorator'
import cloneDeep from 'lodash/cloneDeep'
import isEmpty from 'lodash/isEmpty'
import TaskApi from '@/api/task'
import AreaApi from '@/api/area'
import { checkCarNo, debounce } from '@/utils/util'
import addTaskMixin from './addTaskMixin'
let id: any = 0

const debounceSearch = debounce(300)

@Component({
	components: {
		VNodes: {
			functional: true,
			render: (h: any, ctx: any) => ctx.props.vnodes,
		},
	},
})
export default class Motion extends Mixins(addTaskMixin) {
	public taskType: any = '3'

	public beforeSubmit(values: any) {
		values.injuryPositions = values.injuryPositions.join(',')
		return values
	}

	private get activityPositionList() {
		return this.$store.state.setting.activityPositionList.map((item: any) => {
			return {
				value: item.key,
				label: item.value,
			}
		})
	}

	private getPush(index: number) {
		if (this.addForm.getFieldValue('locationType') === '1') {
			return index % 2 === 0 ? 0 : 2
		} else {
			return index % 2 === 1 ? 0 : 2
		}
	}

	private onLocationChange() {
		this.addForm.resetFields(['code', 'hospital', 'department'])
	}
}
